import React from "react";
import { Space, Table, Typography } from "antd";
import Controls from "./Controls/index";
import CatalogueDetails from "./CatalogueDetails";
import Status from "./Status";
import BuyerActivity from "./BuyerActivity";
import BuyerDetails from "./BuyerDetails";
import Can from "../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import { all } from "@ucast/js";
export default function TableCatalogues({
  data,
  showModal,
  // deactivateCatalogue,
  // deleteCatalogue,
  activateCatalogue,
}) {
  const { Text } = Typography;
  const buyerActivity = (text, row, index) => {
    const { status, buyer_activity } = row;

    return (
      <BuyerActivity
        status={status}
        buyer_activity={buyer_activity}
        index={index}
        details={row.controls}
      />
    );
  };
  // column 1  catalogueDetails
  const catalogueDetails = (text, row, index) => {
    return <CatalogueDetails text={text} row={row} index={index} />;
  };

  // column 2  status
  const status = (text, row, index) => {
    return <Status text={text} row={row} index={index} />;
  };
  // column 3  buyerDetails
  const buyer = (text, row, index) => {
    return <BuyerDetails text={text} row={row} index={index} />;
  };
  // column 4  controls
  const controls = (text, row, index) => {
    return (
      <Controls
        text={text}
        row={row}
        index={index}
        showModal={showModal}
        // deactivateCatalogue={deactivateCatalogue}
        activateCatalogue={activateCatalogue}
        linkSecurityData={row?.linkSecurityData}
        // deleteCatalogue={deleteCatalogue}
      />
    );
  };
  const columns = [
    {
      title: "Catalogue Details",
      dataIndex: "details",
      render: catalogueDetails,
      // width: "33%",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: status,
      // width: "10%",
    },
    {
      title: "Buyer Details",
      dataIndex: "buyer",
      render: buyer,
      // width: "20%",
    },
    {
      title: "Buyer Activity",
      dataIndex: "activity",
      render: buyerActivity,
      width: "17%",
    },
    {
      title: "Controls",
      // (
      //   <Can
      //     I={
      //       PERMISSIONS.global_permissions.slug 
      //       // PERMISSIONS.update_catalogues_link_security.slug ||
      //       // PERMISSIONS.delete_catalogues.slug ||
      //       // PERMISSIONS.create_catalogues.slug ||
      //       // PERMISSIONS.update_catalogues.slug ||
      //       // PERMISSIONS.download_ppt_excel.slug
      //     }
      //     a={PERMISSIONS.global_permissions.permissionType}
      //   >
      //     {(allowed) => (allowed ? "Controls" : null)}
      //   </Can>
      // ),
      dataIndex: "controls",
      render: (text, row, index) => (controls(text, row, index)
      // render: (text, row, index) => (
      //   <Can
      //     I={PERMISSIONS.global_permissions.slug}
      //     a={PERMISSIONS.global_permissions.permissionType}
      //     passThrough
      //   >
      //     {(allowed) => (allowed ? controls(text, row, index) : null)}
      //   </Can>
      ),
    },
  ];

  return (
    <>
      <div>
        <Table
          size="large"
          columns={columns}
          dataSource={data}
          pagination={{ position: ["bottomCenter"] }}
          onChange={(pagiation, filters, sorters) => {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0;
          }}
          className="catalogue-history-table"
          // sticky="false"
          // scroll={{ y: "60vh" }}
        />
      </div>
    </>
  );
}
